import { apiLanguage } from './language';

const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL || 'https://api.tenkusports.com/graphql';

const VENUE_BY_CODE_QUERY = `
  query VenueByCode($code: String!) {
    venueByCode(code: $code) {
      id
      name
      address
      countryCode
      currency
      amenities
      otherAmenities
      contactPhone
      contactPhoneWhatsapp
      acceptsAppBookings
      publicSlug
      logoUrl
      socialLinks {
        instagram
        facebook
        tiktok
        website
      }
      spaces {
        id
        name
        sportTypeIds
        format
        indoor
        photos
        priceFromCents
      }
      eventSpaces {
        id
        name
        capacity
        indoor
        photos
        includes
        rules
      }
      eventTypes
    }
    sportTypes {
      id
      name
    }
  }
`;

export class VenueNotFoundError extends Error {}

const VENUE_CODE_PATTERN = /^[2-9a-hjkmnp-z]{6}$/i;
const NOT_FOUND_DOMAIN_CODE = 'ERR_VENUE_NOT_FOUND';

export const venueCodeFromSlug = (slug) => {
  const value = (slug || '').trim();
  const index = value.lastIndexOf('-');
  return index >= 0 ? value.slice(index + 1) : value;
};

export const isValidVenueCode = (code) => VENUE_CODE_PATTERN.test(code || '');

const isNotFoundError = (error) => {
  const extensions = error.extensions || {};
  if (Number(extensions.code) === 404) return true;
  return Object.values(extensions).some((value) => value === NOT_FOUND_DOMAIN_CODE);
};

export const fetchVenueByCode = async (code, language) => {
  if (!isValidVenueCode(code)) throw new VenueNotFoundError('invalid code');

  const res = await fetch(GRAPHQL_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      lang: apiLanguage(language, 'es'),
    },
    body: JSON.stringify({
      query: VENUE_BY_CODE_QUERY,
      variables: { code: code.toLowerCase() },
    }),
  });

  if (res.status === 404) throw new VenueNotFoundError('not found');
  if (!res.ok) throw new Error(`HTTP ${res.status}`);

  const body = await res.json();
  const venue = body.data?.venueByCode;
  if (venue) return { ...venue, sports: body.data.sportTypes || [] };

  const errors = body.errors || [];
  if (errors.length === 0 || errors.some(isNotFoundError)) throw new VenueNotFoundError('not found');
  throw new Error(errors[0]?.message || 'GraphQL error');
};
